import React, { useState } from 'react'
import PropType from 'prop-types'
import config from 'config'

import RadioGroup from '@cred/react-basic-form-fields/RadioGroup'

import CtaButton from 'components/cta-button'
import { fireGtmEvent } from 'utils/gtm'
import PoweredBy from 'components/powered-by'

import styles from '../student-loan-combined/styles.module.scss'

const radioOptions = [
  { value: 'student', label: 'Student' },
  { value: 'cosigner', label: 'Cosigner' },
]

const StudentLoanForm = (props) => {
  const { queryString, widgetContext, metaQuery, ctaText } = props

  const [href, setHref] = useState('')
  const [role, setRole] = useState('')
  const [error, setError] = useState(null)

  const onChange = (value) => {
    const _role = value === 'cosigner' ? 'cosigner' : 'borrower'

    setError(null)
    setRole(value)
    setHref(
      `${config.credibleRoot}/private-student-loans/get-started?role=${_role}&${queryString}${metaQuery}`,
    )

    fireGtmEvent('fieldChange', { ...widgetContext, inschoolRole: value })
  }

  const onClick = () => {
    if (!role) {
      setError('Select an option above.')
    }

    fireGtmEvent('ctaClick', { ...widgetContext, inschoolRole: role })
  }

  return (
    <>
      <div className={`private-studnet-loans ${styles.selection}`}>
        <p className={`${styles.title} mb-16`}>I'm a...</p>
        <RadioGroup
          id="role"
          name="role"
          className="mb-16"
          inputProps={{
            onChange,
          }}
        >
          {radioOptions.map(({ label, value }) => (
            <option label={label} value={value} key={`radio-${value}`} />
          ))}
        </RadioGroup>
        {error && <p className={`${styles.error} mb-8`}>{error}</p>}
      </div>
      <section className={styles.submit}>
        <CtaButton
          href={href}
          onClick={onClick}
          target="_blank"
          fullWidth
          analytics={{
            data: { text: ctaText, activated: !!role },
          }}
        >
          {ctaText}
        </CtaButton>
        <PoweredBy className="mt-8" />
      </section>
    </>
  )
}

StudentLoanForm.propTypes = {
  widgetContext: PropType.object.isRequired,
  ctaText: PropType.string.isRequired,
  queryString: PropType.string.isRequired,
  metaQuery: PropType.string,
}

export { StudentLoanForm }

export default StudentLoanForm
